import { useToast, useValidatorSeeker } from "@hooks"
import {
	analyzerDate,
	categories,
	currency,
	includeProviders,
	mainProvider,
	mainSite,
	offices,
	providers,
	reports,
	repricingPass,
	searchID,
} from "@signals"
import { isAnalyzerLoading, tableHasMainComparison } from "Pages/AnalyzersV2/@signals"
import { analyzerRequest } from "Pages/AnalyzersV2/@services/analyzerRequestApp"
import { lorSchema } from "Pages/AnalyzersV2/Lor/schema"
import {useCallback, useEffect} from "react"
import { lorPayload } from "Pages/AnalyzersV2/Lor/@signals"
import { loadPassDecisions } from "Pages/AnalyzersV2/@services/decisionsApi"
import { SECTIONS } from "Pages/AnalyzersV2/@constants"


export default function useAnalyzerLorFilters() {
	const { showToast } = useToast()

	const { isValid, errorRegistry } = useValidatorSeeker({
		currency: currency.value,
		officePickupID: offices.value,
		groupBySiteProvider: includeProviders.value,
		dates: analyzerDate.value,
		providerID: providers.value,
		categoryID: categories.value
	}, lorSchema(searchID.value))

	// `keep` (a car picked, Min / Max; CU-869fmpqfm C1): the table stays under "Updating…" and nothing is reset
	const onSubmit = useCallback((clearTab = false, { keep = false } = {}) => {
		tableHasMainComparison.value = !!mainSite.value || !!mainProvider.value
		const payload = lorPayload.value
		analyzerRequest.run({
			payload, type: SECTIONS.LOR, keep, clearTab,
			onError: () => showToast.error(),
			// the engine's decisions on the cells, only with a pass (CU-869fmm949)
			after: () => { if (repricingPass.value) loadPassDecisions(payload) },
		})
	}, [isAnalyzerLoading.value, repricingPass.value])

	return {
		onSubmit: onSubmit,
		isValid: (isValid && (!!reports.value || !!repricingPass.value)) || !!searchID.value,
		errorRegistry: errorRegistry
	}
}